module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "model": "persons",
      "entity": _vm.person,
      "fields": _vm.fields,
      "ignoreEntityChanges": "",
      "after-submit": _vm.afterSubmit
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c672316!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/person/PersonForm.vue
// module id = 1016
// module chunks = 2